<template>
  <DpplEnhancedTooltip
    v-if="
      typeof atsTotalApplicants === 'number'
        && authData.isApplicationReportingEnabled
        && reqReportUrl"
    position="bottom start"
    :offset="0"
    max-width="300px"
    close-on-content-click
  >
    <template #activator>
      <div class="total-applicants-activator" v-bind="$attrs">
        <ApplicantIcon class="mr-1" />
        <p class="p5">
          {{ formatNumber(atsTotalApplicants) }}
        </p>
      </div>
    </template>
    <div class="d-flex flex-column align-center justify-start">
      <p class="p5 font-weight-medium">
        Total Applicants on Requisition
      </p>
      <h4 class="mt-2">
        {{ formatNumber(atsTotalApplicants) }}
      </h4>
      <ReqProgressButton class="d-flex align-center justify-center" />
    </div>
  </DpplEnhancedTooltip>
</template>

<script setup>
import DpplEnhancedTooltip from '@/components/datapeople/DpplEnhancedTooltip.vue';
import { useEditor } from '@/stores/editor/editor';
import { storeToRefs } from 'pinia';
import ReqProgressButton from '@/components/editor/ReqProgressButton.vue';
import { numberWithCommas } from '@/helpers/formatters';
import { useAppAuthData } from '@/stores/app/authData';
import ApplicantIcon from '@/assets/icon-applicant.svg?component';

const { atsTotalApplicants, reqReportUrl } = storeToRefs(useEditor());
const { authData } = storeToRefs(useAppAuthData());

const formatNumber = (value) => numberWithCommas(value);
</script>

<style scoped lang="less">
.total-applicants-activator {
  height: 100%;
  display: flex;
  align-items: center;
}
</style>
